import { render, staticRenderFns } from "./ProjectModal.vue?vue&type=template&id=3084bc00"
import script from "./ProjectModal.vue?vue&type=script&lang=js"
export * from "./ProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports